"use client";
import { jsx } from "react/jsx-runtime";
import { ColorGray900 } from "@nxt-costco-com/forge-design-tokens";
import { Text } from "../../DataDisplay/Text/index.js";
import { COMPONENT_ERROR, COMPONENT_NAME } from "./constants.js";
import { StyledBreadcrumb, StyledLastLink } from "./styles.js";
import { Link } from "../Link/index.js";
import { getDataTestId } from "../../Util/index.js";
const Breadcrumbs = ({
  maxItems,
  breadcrumbElements,
  separator,
  ariaLabel,
  expandText,
  isLastElementClickable = false,
  uniqueId
}) => {
  if (breadcrumbElements === void 0) {
    console.error(COMPONENT_ERROR);
    return null;
  }
  return /* @__PURE__ */ jsx(
    StyledBreadcrumb,
    {
      "data-testid": getDataTestId(COMPONENT_NAME, uniqueId),
      ...maxItems && { maxItems },
      ...separator && { separator },
      "aria-label": ariaLabel,
      expandText,
      children: breadcrumbElements.map(
        (data, index) => index === breadcrumbElements.length - 1 ? isLastElementClickable ? /* @__PURE__ */ jsx(
          StyledLastLink,
          {
            href: data.link,
            "aria-current": "page",
            "data-testid": `Link_${index}`,
            children: data.name
          },
          data.name
        ) : /* @__PURE__ */ jsx(
          Text,
          {
            component: "p",
            "aria-current": "page",
            uniqueId: `${index}`,
            children: data.name
          },
          data.name
        ) : /* @__PURE__ */ jsx(
          Link,
          {
            href: data.link,
            underline: "hover",
            color: ColorGray900,
            uniqueId: `${index}`,
            children: data.name
          },
          data.name
        )
      )
    }
  );
};
Breadcrumbs.displayName = COMPONENT_NAME;
export {
  Breadcrumbs
};
